import { getLessonProgressById } from "@/api/api";

export const namespaced = true;

export const state = {
  module: null,
  lesson: null,
};
export const mutations = {
  module: (state, payload) => {
    state.module = payload;
  },
  lesson: (state, payload) => {
    state.lesson = payload;
  },
};
export const getters = {
  module: (state) => state.module,
  lesson: (state) => state.lesson,
};
export const actions = {
  updateLesson: async (context, payload) => {
    const response = await getLessonProgressById(payload);
    if (response) {
      context.commit("lesson", response.data);
    }
  },
};
